import React from "react";
import Top from "../../Top";
import Left from "../../Left";
import { Grid } from "@mui/material";
// import VisitorsManagementTable from "./VisitorsManagementTable";
// import DemoTable from "./DemoTable";
import {useEffect,useMemo} from 'react'; 
import swal from "sweetalert"; 
import { makePostRequest } from "../../../utils/utils";
import DataTable from 'react-data-table-component';
import { useNavigate } from "react-router-dom";


function VisitorsManagement() {

  const headCells  = useMemo(
    () => [
    {
      name: 'Visitor Id',
        selector: 'visitor_id',
        sortable: true     
     
    },
    {
      name: 'Visitor Names',
      selector: (row) => {
        const info = row.user_obj.first_name +" " +row.user_obj.last_name;
        return <div>{info}</div>;
        },
      sortable: true
    },
    {
      name: 'Contact No',
      selector: (row) => {
        const info = row.user_obj.contact_no;
        return <div>{info}</div>;
        },
      sortable: true,
      
    },
  
    {
      name: 'Email-Id',
      selector: (row) => {
        const info = row.user_obj.email_id;
        return <div>{info}</div>;
        },
      sortable: true
    },
    {
      name: 'Visited Flat',
        selector: 'visited_flatId',
        sortable: true
    },
    {
      name: 'Entry Time',
        selector: 'entry_time',
        sortable: true
    },
    {
      name: 'Exit Time',
      selector: 'exit_time',
        sortable: true
    },
    {
      name: 'Purpose',
      selector: 'purpose',
        sortable: true
    },
    {
      name: 'Status',
      selector: 'purpose',
        sortable: true
    },
    {
      name: 'Approve By',
      selector: 'approve_by',
        sortable: true
    }
   
  ],[]);
 
  const [q]=React.useState('');

  useEffect(() => {

  if(q.length>0)
  {
    getAllVisitors();
      
  }
  else
  {
    getAllVisitors();
  }
}, [q]);

//all amenitieslisting
const [, setPage] = React.useState(0);
// const [dense, setDense] = React.useState(false);
// const [rowsPerPage, setRowsPerPage] = React.useState(5);
const [paged] = React.useState(1);
  const [, setPages] = React.useState(1);
  const countPerPage = 5;
const [visitorList,setVisitorsList]=React.useState([])

async function getAllVisitors() {
  let bodyFormData={}

 // http://localhost:8001/api/v1/visitor/visitorlisting?searchq=john&pageNo=1&count=10
 makePostRequest('visitor/visitorlisting?searchq=&pageNo=1&count=10', bodyFormData).then((response) => {
      if (response.status === 201) {
        console.log(response.data.data.rowCount)
          // setlength(response.data.data.rowCount)
          const data =response.data.data.rows;
          console.log(data);
          setVisitorsList(data);

       }else{
          swal("There was an error!", response.message, "warning");
      }
}).catch((err) => {
swal("There was an error!", "more error details",  "warning");});
}

  const navigate = useNavigate();

  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12} className="oneLineBt">
            <h1 className="panelHeading">Visitor Management</h1>
          </Grid>
          <Grid item xs={12} md={12}>
            <div className="residentManagementTable">
              {
            (q.length>0) 
    ?
    <DataTable 
                  columns={headCells}
                  data={visitorList}
                  highlightOnHover
                  pagination
                  paginationDefaultPage={1}
                  paginationServer
                  paginationTotalRows={visitorList.length}
                  paginationPerPage={countPerPage}
                  paginationComponentOptions={{
                    noRowsPerPage: true
                  }}
                  onChangePage={pages => setPages(pages)}

                /> 
    : <DataTable 
              columns={headCells}
              data={visitorList}
              highlightOnHover
              currentPage={paged}
              pagination
              paginationDefaultPage={1}
              paginationResetDefaultPage={1}
              paginationServer
              paginationTotalRows={visitorList.length}
              paginationPerPage={countPerPage}
              paginationComponentOptions={{
                noRowsPerPage: true
              }}
              onChangePage={page => setPage(page)}
            /> 
  
 }     
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
}

export default VisitorsManagement;
